import React from 'react';
import { InputUI } from '../Interface';

const CommentMessageField = (props) => {
  return <InputUI name="message" placeholder="Hozzászólás írása..." multiline rows={2} autoFocus {...props} />;
};

export default CommentMessageField;
